var couRefile;

couRefile = function () {
  $(document).on("upload:start", "form", function (e) {
    var label;
    $(this).find("input[type=submit]").attr("disabled", true);
    label = $("#" + e.target.id).closest(".coufigure-fields");
    label.find("figure img").remove();
    return label.find(".text span").html("0%");
  });
  $(document).on("upload:progress", "form", function (e) {
    var detail, label, percentComplete;
    detail = e.originalEvent.detail;
    percentComplete = Math.round((detail.loaded / detail.total) * 100);
    label = $("#" + e.target.id)
      .closest(".coufigure-fields")
      .find(".coufigure-label");
    label.find(".loading").css("width", percentComplete + "%");
    return label.find(".text span").html(percentComplete + "%");
  });
  return $(document).on("upload:success", "form", function (e) {
    var imageData, label, resetUploadStatus;
    if (!$(this).find("input.uploading").length) {
      $(this).find("input[type=submit]").removeAttr("disabled");
    }
    imageData = $.parseJSON(
      $("#" + e.target.id)
        .prev("input[type=hidden]")
        .val()
    );
    label = $("#" + e.target.id)
      .closest(".coufigure-fields")
      .find(".coufigure-label");
    label.find(".loading").css("width", 0);
    label.find(".text span").html("Image uploaded");
    label.find("figure").html(
      $("<img />").attr({
        src: "/attachments/cache/limit/600/600/" + imageData.id + "/image",
      })
    );
    resetUploadStatus = function () {
      return label.find(".text span").html("Choose image");
    };
    return setTimeout(resetUploadStatus, 2000);
  });
};

$(document).on("page:load", couRefile);

$(function () {
  return couRefile();
});

// ---
// generated by coffee-script 1.9.2
